<template>
    <div style="background-color:#ffffff;">
        <div class="section">
            <div class="columns">
                <div class="column is-half">
                    <p class="has-text-centered">
                        <a href="https://www.strommehotellet.no" target="_blank" alt="Lenke til Strømmehotellets nettsider">    
                            <img src="../../assets/images/logo2021_h250.jpg" alt="Strømmehotellet" width="400px;">
                        </a>
                    </p>
                    <p class="is-size-4 is-size-5-touch forty">Hos oss kan du også skape digitale møter og konferanser. Dette konseptet har vi døpt <a href="https://www.strommehotellet.no" target="_blank" alt="Lenke til Strømmehotellet">Strømmehotellet</a>. I hotellets studioer livestrømmer vi møter og produserer webinarer, SoMe-klipp, hel- og halvdagskonferanser og masse annet videorelatert. Strømming og video-opptak kan også være en del av en mer tradisjonell konferanse - altså en "hybridkonferanse". Vi er ikke bare et hotell og ikke bare et videoproduksjonsselskap! Med 15 års erfaring i å produsere møter er vi et naturlig valg også for digitale konferanser. <a href="mailto:jonas@generalhotell.no?subject=Streaming">Ta kontakt i dag</a> for en uforpliktende strømmeprat!</p>
                    <p class="has-text-centered sixty">
                        <a class="button  is-outlined is-black is-medium" href="https://www.strommehotellet.no" alt="Lenke til Strømmehotellet">Les mer</a>
                    </p>
                </div>
                <div class="column is-half has-text-centered">                    
                    <video-player 
                        :options="videoOptions"             
                        class="has-text-centered vjs-16-9"        
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VideoPlayer from "@/components/VideoPlayer.vue";

export default {
	name: "Stromming",
	components: {
		VideoPlayer
	},
	data() {
		return {
			videoOptions: {
				autoplay: 'muted',
                controls: true,
                loop: true,                
                fluid: true,  
                aspectRatio: "16:9", 
                poster: "https://image.mux.com/901KMRE45VdL8aiTrCOJzYUGwTCJomTNh007gQYgRjZQc/animated.gif?width=628&start=5.200000000000001",
				sources: [
					{
						src:
							"https://stream.mux.com/901KMRE45VdL8aiTrCOJzYUGwTCJomTNh007gQYgRjZQc.m3u8",
                        type: "application/x-mpegURL",                        
					}
				]
			}
		};
	}
};

</script>

<style scoped>
.forty {
    margin-top: 20px;
}

.sixty {
    margin-top: 40px;
}
@media only screen and (max-width: 1000px) {
    .forty {
        margin-top: 20px;
    }

    .sixty {
        margin-top:30px;
        margin-bottom: 20px;
    }
}
</style>